<style>
    #modalFiltro .k-invalid + .k-form-error.k-invalid-msg {
        display: block !important;
    }
</style>
<template>
    <div id="modalFiltro">
        <form ref="form" v-kendo-validator="validatorOptions()" @submit.prevent="submitDefault">
            <b-modal :scrollable="scrollable" v-model="show" no-close-on-backdrop :size="size" @hide="close" v-bind:hide-footer="hideFooter">
                <template v-slot:modal-title>
                    <i class="fas fa-filter"></i>&nbsp;Filtro
                </template>
                <slot></slot>
                <template v-slot:modal-footer>
                    <div class="row">
                        <b-btn-group class="mr-2">
                            <b-btn block variant="default" @click="close">Fechar</b-btn>
                        </b-btn-group>
                        <b-btn-group class="mr-2" v-if="showSubmit">
                            <b-btn block variant="info" :disabled="disableSubmit" type="submit">Filtrar</b-btn>
                        </b-btn-group>
                    </div>
                </template>
            </b-modal>
        </form>
    </div>
</template>
<script>
export default {
  props: {
    model: "",
    size: { default: '' },
    hideFooter: { default: false },
    submit: Function,
    disableSubmit: { type: Boolean, default: false },
    showSubmit: { type: Boolean, default: true },
    scrollable: { type: Boolean, default: true },
    beforeSubmitEnable : { type: Boolean, default: false},
    beforeSubmit: {type: Function}
  },
  data () {
    return {
      show: false,
      countDiferences: 0,
      defaultModel: {}
    }
  },
  methods: {
    openModal () {
      this.show = true
    },
    close: function () {
      this.countDiferences = 0
      // Pensar melhor
      // if (!_.isEqual(this.$parent.$data[this.model], this.defaultModel)) {
      //    var chaves = Object.keys(this.$parent.$data[this.model])
      //    for (var i = 0; i < chaves.length; i++) {
      //        // uma das duas chaves deve existir e estar com valor informado
      //        if (this.$parent.$data[this.model][chaves[i]] || this.defaultModel[chaves[i]]) {
      //            if (!_.isEqual(this.$parent.$data[this.model][chaves[i]], this.defaultModel[chaves[i]]))
      //                this.countDiferences++
      //        }
      //    }
      // }
      this.show = false
    },
    validate () {
      var isValid = this.$api.UI.FormValidate(this)
      if (!isValid) { this.$api.UI.HideLoading() }
      return isValid
    },
      submitDefault: function (e) {
      e.preventDefault()
          if (this.validate()) {
              if (this.submit) {
          this.submit() 
        } else {
            if (this.beforeSubmitEnable) {
                var isValid = this.beforeSubmit()
                if(!isValid) return
            }
          this.close()
          this.$emit('refresh')
        }
      }
    },
    validatorOptions: function () {
      return {
        rules: {
          money: function (input) {
            var el = input[0]
            el.setCustomValidity('')
            if (el.getAttribute('required') && el.getAttribute('data-value')) {
              var value = kendo.parseFloat(el.value)
              if (value <= 0) {
                el.setCustomValidity('é obrigatório')
                return false
              }
            }    
            return true
          }
        },
        errorTemplate: ''// '<span class="k-form-error k-invalid-msg" data-for="search" id="search-error"><span class="k-icon k-i-warning"> </span>&nbsp;#=message#</span>'
      }
      }
  },
  mounted: function () {
    this.defaultModel = this.$api.UTIL.Functions.CopyObject(this.$parent.$data[this.model])
  }
}
</script>
